import type { SxProps, Theme } from '@mui/material';
import Link from '@mui/material/Link';
import Typography, { type TypographyProps } from '@mui/material/Typography';

interface Props {
  text?: string;
  linksSx?: SxProps<Theme>;
  typographySx?: SxProps<Theme>;
  variant?: TypographyProps['variant'];
}

export const TextWithLinks = ({
  text,
  linksSx,
  typographySx,
  variant,
}: Props) => {
  if (!text) return null;

  // Regex to match URLs starting with http:// or https://
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);

  return (
    <Typography
      sx={{ ...typographySx, wordBreak: 'break-word' }}
      variant={variant}
      component="span"
    >
      {parts.map((part, index) => {
        if (part === '') {
          return null;
        }
        if (urlRegex.test(part)) {
          return (
            <Link
              key={`link-${index}-${part}`}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              sx={linksSx}
              variant={variant}
            >
              {part}
            </Link>
          );
        }
        return part;
      })}
    </Typography>
  );
};
